<template>
  <section class="pb-16">
    <h3 class="sr-only">
      Løsningsforslag
    </h3>
    <UVideoSolution class="mb-10" />
    <UMathTaskAssignments show-suggestions />
  </section>
</template>
